import React, {
  useState,
  forwardRef,
  useEffect,
  useImperativeHandle
} from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { get, post } from "../../../services/api";
import { Badge } from "react-bootstrap";

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Select from "react-select";
import { toast } from "react-toastify";
import { Row, Card, Col, Button, Modal, Container } from "react-bootstrap";

const SendLetter = forwardRef((props, ref) => {
  const { instance, accounts } = useMsal();
	const [formData, setFormData] = useState({
    body: `<p>Hi #title# #firstName# #lastName#</p>\n\n\n\n <br><br>
<p>Regards,<br> ${props?.user?.firstName} ${props?.user?.lastName}</p>`
  });

  const [templates, settemplates] = useState([]);
  const [show, setshow] = useState(false);
  const [selectedtemplate, setselectedtemplate] = useState();
  useEffect(() => {
    gettemplates();
  }, []);

  useEffect(()=>{
    if(props.user) {
      
      setFormData({ ...formData,  body: `<p>Hi #title# #firstName# #lastName#</p>\n\n\n\n <br><br>
        <p>Regards, <br> ${props?.user?.firstName} ${props?.user?.lastName}</p>` });
    }
  },[props.user])

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  useImperativeHandle(ref, () => ({
    showLetterModal() {
      setselectedtemplate();
      setshow(true);

    },
  }));

  const gettemplates = async () => {
    const response = await get('/api/template', props.token);
    settemplates(response)
  }
  
  const sendLetter =async()=> {
    
    const reqbody = {
      templateId: selectedtemplate?._id,
      emails: props.data.map(e=>e.email).join(","),
      body: formData?.body,
      subject: formData?.subject,
      candidates: props.data,
      isCompany: props.data
    }
    if (accounts?.length > 0) {
      const accessToken = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });
      reqbody.accessToken = accessToken.accessToken
    }
    
    await post('api/template/send',reqbody,props.token)
    toast.success("Letter send successfully.");
    setshow(false);
  }


  return (
    <>
      <Modal className="fade" show={show} onHide={()=>setshow(false)}>
				<Modal.Header>
					<Modal.Title>Select Letter to Send</Modal.Title>
					<Button variant="" className="btn-close" onClick={() => setshow(false)}></Button>
				</Modal.Header>
				<Modal.Body>
        <div className="row">
        <Select
                menuPosition="fixed"
                options={
                  templates.map(l=> {
                      return { label: l.fileName, value: l._id }
                    })
                  }
                onChange={(selectedOption) =>
                  
                  setselectedtemplate(selectedOption ? templates.filter(d=> d._id === selectedOption.value)[0] : {})
                }
              />
                <div className="col-xl-12 mb-12">
                <div className="compose-wrapper mt-3" id="compose-content">
                  <div className="compose-content">
                    <form >
                      <div className="form-group mb-3">
                      <div className="bootstrap-badge" style={{border: '1px solid rgba(0, 0, 0, 0.1)', padding: '5px', borderRadius: '5px'}}>
                      &nbsp;&nbsp;&nbsp;&nbsp;To : &nbsp;
                        {props.data.map(data => props.isCompany ? <>
                          {data.compContacts?.map(d=>
                            <Badge bg="info" className='me-2'>{d?.email}</Badge>
                          )}
                        </> 
                        :
                          <Badge bg="info" className='me-2'>{data?.email}</Badge>
                        )}
                         </div>
                      </div>
                      <div className="form-group mb-3">
                      <input type="text" className="form-control bg-transparent" placeholder=" Subject:"
                       required
                       value={formData?.subject}
                       onChange={(e) =>
                         handleInputChange("subject", e.target.value)
                       }
                      />
                      </div>
                      <div className="form-group mb-3">
                      <Badge  bg="" className='badge-secondary light'><i className="fa fa-info me-2"></i>
                      { props?.hint ? props?.hint : "Please use #title#, #firstName# , #lastName# to dynamically map values"}</Badge>
                    
                      {/* <textarea id="email-compose-editor" className="textarea_editor form-control bg-transparent" rows="5"
                        required
                        value={formData?.body}
                        onChange={(e) =>
                          handleInputChange("body", e.target.value)
                        }
                        placeholder="Enter text ..."
                      ></textarea> */}
                      <hr />
                                <CKEditor
                                data={formData?.body}
                                    editor={ ClassicEditor }
                               
                                    onReady={ editor => {
                                        
                                    } }
                                    onChange={ ( event, editor ) => {
                                        const data = editor.getData();
                                        handleInputChange("body", data)
                                        //console.log('data',data)
                                        
                                    } }
                                    onBlur={ ( event, editor ) => {
                                       
                                    } }
                                    onFocus={ ( event, editor ) => {
                                       
                                    } }
                                />
                          
                      </div>
                    </form>
                    {/* <h5 className="my-3"><i className="fa fa-paperclip me-2"></i> Attatchment</h5>
                    <DropFile /> */}
                    
                  </div>
                  
                  </div>
                </div>	
          </div>
        
        </Modal.Body>
				<Modal.Footer>
					<Button  variant="danger light" onClick={() => setshow(false)}>Close</Button>
					<Button 
          disabled={!selectedtemplate} 
          variant="primary"
          onClick={() => {sendLetter();}}
          >Send</Button>
				</Modal.Footer>
			</Modal>
    </>
  );
});

export default SendLetter;
